<template>
  <v-dialog v-model="verifyModal" max-width="500">
    <v-card>
      <v-card-title v-if="verifyModalStatus === $store.getters.verifyStatuses.REFINE">
        <h2>{{$t('Loads.RefineNotes')}}</h2><v-spacer></v-spacer><v-btn icon @click="verifyModal=false;"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-title v-if="verifyModalStatus === $store.getters.verifyStatuses.REFINED">
        <h2>{{$t('Loads.RefinedNotes')}}</h2><v-spacer></v-spacer><v-btn icon @click="verifyModal=false;"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-title v-if="verifyModalStatus === $store.getters.verifyStatuses.EDITING_REQUEST">
        <h2>{{$t('Loads.RequestEditUnlockNotes')}}</h2><v-spacer></v-spacer><v-btn icon @click="verifyModal=false;"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-title v-if="verifyModalStatus === $store.getters.verifyStatuses.WAITING_FURTHER_ACTIONS">
        <h2>{{$t('Loads.MarkAsWaitingFurtherActions')}}</h2><v-spacer></v-spacer><v-btn icon @click="verifyModal=false;"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex xs12>
            <v-textarea dense outlined
                        :error-messages="verifyModalNoteErrorMsg"
                        v-model="verifyModalNote"></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <v-btn @click="verifyModalEditId > 0 ? updateVerifyNote() : addVerifyNote()" color="primary" width="100%">
              {{verifyModalEditId > 0 ? $t('Update') : $t('Save')}}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LoadVerifyModal',
  props: ['modal', 'item'],
  components: { },
  data () {
    return {
      verifyModal: false,
      verifyModalEditId: 0,
      verifyModalStatus: 0,
      verifyModalNote: '',
      verifyModalNoteErrorMsg: ''
    };
  },
  computed: {
  },
  mounted () {
    this.verifyModal = this.modal || false;
    this.verifyModalStatus = this.item.status || 0;
    this.verifyModalEditId = this.item.id || 0;
    this.verifyModalNote = this.note || '';
  },
  methods: {
    // TODO make this work
    updateVerifyNote () {
      this.$emit('on-note-update', this.verifyModalEditId, this.verifyModalNote);
    },
    addVerifyNote () {
      this.$emit('on-add', this.userId, this.loadId);
    }
  }
};
</script>
